import { priceName } from '@dashboard/scenes/PageEdit/scenes/PageProduct/components/OrderBumps/describeBumpRule';
import { getPriceHeadline } from '@dashboard/scenes/PageEdit/scenes/PageProduct/components/PricesList/priceHelpers';
import getTicketPriceHeadline from '@dashboard/services/event/getTicketPriceHeadline';

export const couponPriceOption = price => ({
  id: String(price._id),
  name: priceName(price),
  detail: price.label ? getPriceHeadline(price, { amountsInCents: true }) : null,
});

// A disabled price stays listed while the coupon is limited to it, so the limit can be cleared.
export const productPriceOptions = (product, selectedIds = []) =>
  (product?.prices ?? [])
    .filter(price => price.enabled !== false || selectedIds.includes(String(price._id)))
    .map(couponPriceOption);

export const bumpOption = entry => ({
  id: String(entry.productId),
  name: entry.product?.title ?? '',
  detail: entry.price ? getPriceHeadline(entry.price, { amountsInCents: true }) : null,
});

// Like prices, a switched-off bump stays listed while the coupon names it.
export const pageBumpOptions = (orderBumps = [], selectedIds = []) =>
  orderBumps
    .filter(
      entry =>
        (entry.enabled !== false && !entry.unavailableReason) ||
        selectedIds.includes(String(entry.productId)),
    )
    .map(bumpOption);

export const ticketOption = (ticket, currency) => ({
  id: String(ticket._id),
  name: ticket.name,
  detail: getTicketPriceHeadline({ ticketType: ticket, currency }),
});

// "$20 / month" reads "$20/month" inside a sentence's brackets.
export const compactDetail = option => ({
  ...option,
  detail: option.detail?.replace(' / every ', ' every ').replace(' / ', '/') ?? null,
});
